import { render, staticRenderFns } from "./PReadMore.vue?vue&type=template&id=650357bf"
import script from "./PReadMore.vue?vue&type=script&lang=js"
export * from "./PReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports